import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import { IconProps } from "./types";

export function CircleMinusIcon({ size, ...props }: IconProps) {
    return <RemoveCircleOutlineRoundedIcon fontSize={size} {...props} />;
}
